app.controller('BrowseProductIndividualPanelController', ['$rootScope', '$scope', function ($rootScope, $scope) {

    const navigationIDs = $scope.navigation_ids;
    const productModel = $rootScope.factory.product_panel.getModel(navigationIDs);

    $scope.product = productModel.product;
    productModel.apiRequire(function () {
        $scope.product = productModel.product;
    })

    const documentProductTag = "panel";

    $scope.product_document = null;
    $rootScope.service.cache_local_server.productDocumentsByTags([navigationIDs.site_range_id, documentProductTag], function (documents) {
        $scope.product_document = documents.length > 0 ? documents[0] : null;
    })


    $scope.addToCartHandler = function (validateFormCallback, product) {

        const categoryCartID = $scope.category_cart_id ? $scope.category_cart_id : null;

        let angleLength = product.option_term_values.panel_angle ? product.option_term_values.panel_angle.angle_length : null;
        let angleDepth = product.option_term_values.panel_angle ? product.option_term_values.panel_angle.angle_depth : null;

        if (!angleLength && !angleDepth) {
            angleLength = product.option_term_values.panel_side_angle ? product.option_term_values.panel_side_angle.angle_length : null;
            angleDepth = product.option_term_values.panel_side_angle ? product.option_term_values.panel_side_angle.angle_depth : null;
        }

        const orderLine = {

            type: product.api_code,
            product_code: product.api_code,

            quantity: product.quantity,
            cost: product.displayPrice(),

            range: product.getSubmitRangeID(),
            colour: navigationIDs.colour_id,
            style: navigationIDs.style_id,
            length: product.length,
            depth: product.depth,
            height: product.height,
            width: product.width,
            diameter: product.diameter,

            thickness: product.thickness,

            front_profiled: product.option_term_values.panel_profiled_edge ? product.option_term_values.panel_profiled_edge.front_profiled : null,
            back_profiled: product.option_term_values.panel_profiled_edge ? product.option_term_values.panel_profiled_edge.back_profiled : null,
            left_profiled: product.option_term_values.panel_profiled_edge ? product.option_term_values.panel_profiled_edge.left_profiled : null,
            right_profiled: product.option_term_values.panel_profiled_edge ? product.option_term_values.panel_profiled_edge.right_profiled : null,

            angle_length: angleLength,
            angle_depth: angleDepth,
            front_left_angle: product.option_term_values.panel_angle ? product.option_term_values.panel_angle.front_left_angle : null,
            front_right_angle: product.option_term_values.panel_angle ? product.option_term_values.panel_angle.front_right_angle : null,
            back_left_angle: product.option_term_values.panel_angle ? product.option_term_values.panel_angle.back_left_angle : null,
            back_right_angle: product.option_term_values.panel_angle ? product.option_term_values.panel_angle.back_right_angle : null,

            front_left_radius: product.option_term_values.panel_radius ? product.option_term_values.panel_radius.front_left_radius : null,
            front_right_radius: product.option_term_values.panel_radius ? product.option_term_values.panel_radius.front_right_radius : null,
            back_left_radius: product.option_term_values.panel_radius ? product.option_term_values.panel_radius.back_left_radius : null,
            back_right_radius: product.option_term_values.panel_radius ? product.option_term_values.panel_radius.back_right_radius : null,

            corner_position: product.option_term_values.panel_corner_position ? product.option_term_values.panel_corner_position.corner_position : null,

            side_length: product.option_term_values.panel_side_angle ? product.option_term_values.panel_side_angle.side_length : null,
            side_depth: product.option_term_values.panel_side_angle ? product.option_term_values.panel_side_angle.side_depth : null,

            corner_radius: product.option_term_values.panel_corner_radius ? product.option_term_values.panel_corner_radius.corner_radius : null,
            middle_radius: product.option_term_values.panel_corner_radius ? product.option_term_values.panel_corner_radius.middle_radius : null,

            side_length_profiled: product.option_term_values.panel_corner_profile ? product.option_term_values.panel_corner_profile.side_length_profiled : null,
            side_depth_profiled: product.option_term_values.panel_corner_profile ? product.option_term_values.panel_corner_profile.side_depth_profiled : null,

            category_cart_id: categoryCartID,

            product_model_id: product.model_id,
            parent_category_ids: product.parent_category_ids,

            group_name: product.group_name


        };

        const orderBuild = {
            range: orderLine.range,
            colour: orderLine.colour,
            style: orderLine.style,
            lines: [orderLine]
        };

        $rootScope.service.product.addToCart(orderBuild, function (success, messages) {
            if (success) {

                $rootScope.service.product.resetProduct(product);

                product.quantity = 1;
                product.length = '';
                product.depth = '';
                product.diameter = '';
                product.thickness = product.default_thickness;
                product.applynonstdsurcharge = false;
                product.price = 0;
                product.profiled_f = false;
                product.profiled_b = false;
                product.profiled_l = false;
                product.profiled_r = false;
                product.angle_length = '';
                product.angle_depth = '';
                product.front_left_angle = false;
                product.front_right_angle = false;
                product.back_left_angle = false;
                product.back_right_angle = false;
                product.front_left_radius = '';
                product.front_right_radius = '';
                product.back_left_radius = '';
                product.back_right_radius = '';
                product.corner_position = '';
                product.side_length = '';
                product.side_depth = '';
                product.angle_length = '';
                product.angle_depth = '';
                product.corner_radius = '';
                product.middle_radius = '';
                product.side_length_profiled = false;
                product.side_depth_profiled = false;

            }
            if (validateFormCallback) {
                validateFormCallback(success, messages);
            }
        });
    };


}]);